import * as History from 'history';

// @todo remove once our routing is more standardize
// this is a temporary measure to handle our early funnel redirections
const isRedirectedFromAuto = (location: History.Location) => {
  const autoProductParam = location?.search?.includes('product=auto');

  return autoProductParam;
};

export default isRedirectedFromAuto;
